/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryDistributionCarrierBySupplierFilter
 */
export interface AncillaryDistributionCarrierBySupplierFilter {
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryDistributionCarrierBySupplierFilter
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {number}
     * @memberof AncillaryDistributionCarrierBySupplierFilter
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof AncillaryDistributionCarrierBySupplierFilter
     */
    term?: string | null;
}

export function AncillaryDistributionCarrierBySupplierFilterFromJSON(json: any): AncillaryDistributionCarrierBySupplierFilter {
    return AncillaryDistributionCarrierBySupplierFilterFromJSONTyped(json, false);
}

export function AncillaryDistributionCarrierBySupplierFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryDistributionCarrierBySupplierFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'term': !exists(json, 'term') ? undefined : json['term'],
    };
}

export function AncillaryDistributionCarrierBySupplierFilterToJSON(value?: AncillaryDistributionCarrierBySupplierFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'limit': value.limit,
        'term': value.term,
    };
}


